export default __webpack_public_path__ + "static/media/036-keep left.536a6a5c.png";